









































import { Mixins } from 'vue-property-decorator'
import { TheClientChoiceTRMixin } from '@core/components/TheClientChoiceTRMixin'

export default class TheClientChoiceTR extends Mixins(TheClientChoiceTRMixin) {
}
